import React, { useCallback, useEffect, useRef, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../styles'
import { ServiceContentModel } from '../../../../types/services/serviceModel'
import { useHistory, useRouteMatch } from 'react-router'
import { FormattedMessage, useIntl } from 'react-intl'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import links from '../../../../enums/linksEnum'
import { displaySnackbar } from '../../../reducers/snackBar/actions'
import fetchFactory from '../../../../utils/fetchFactory'
import { RootState } from '../../../reducers'
import errorCatcher from '../../../../utils/errorCatcher'
import { saveServices } from '../../../reducers/services/actions'
import Loader from '../../../../components/loader/Loader'
import Link from '../../../../components/link/Link'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import parse from 'html-react-parser'
import ServiceCarousel from './ServiceCarousel'
import { displayModal } from '../../../reducers/modal/actions'
import { modalTypes } from '../../../../enums/modalTypeEnum'
import { AccessibilityModel } from '../../../../types/accessibility/accessibilityModel'
import { Theme } from '@material-ui/core'

const useStyle = makeStyles<Theme, { accessibility: AccessibilityModel }>(
	(theme) => (
		{
			...styles(theme),
			detailsContainerStyle: {
				position: 'relative',

				'& h1': {
					margin: 0,
					color: theme.palette.accessibility.main,
					wordBreak: 'break-word'
				},
				'& h2': {
					color: theme.palette.blue.main,
					wordBreak: 'break-word'
				},
				'& h3': {
					color: theme.palette.blue.main,
					wordBreak: 'break-word'
				},
				'& h4': {
					color: theme.palette.blue.main,
					wordBreak: 'break-word'
				},
				'& h5': {
					color: theme.palette.blue.main,
					wordBreak: 'break-word'
				},
				'& h6': {
					color: theme.palette.blue.main,
					wordBreak: 'break-word'
				},
				'& p, & li': {
					color: theme.palette.blue.main,
					wordBreak: 'break-word'
				},
				'& a': {
					color: theme.palette.green.main,

					'&::before': {
						display: 'none'
					}
				},
				'& img': {
					maxWidth: '100%'
				},
				'& table': {
					width: '100%',
					borderCollapse: 'collapse',

					'& caption': {
						color: theme.palette.blue.main,
						textAlign: 'left'
					},
					'& thead': {
						background: 'white',

						'& th': {
							color: theme.palette.blue.main,
							textAlign: 'left'
						}
					},
					'& tbody tr': {
						background: theme.palette.blue['5'],

						'& td': {
							color: theme.palette.blue.main
						}
					},
					'& tbody tr:nth-child(2)': {
						background: theme.palette.blue['10']
					}
				},
                '& ul, & ol': {
                    paddingLeft: 15,
                },
                '& ul': {
                    listStyle: props => props.accessibility.isVisualHandicap ? 'url("img/listIconBlue.svg")' : 'url("img/listIcon.svg")'
                },

				'& .encart': {
					'& > h1': {
						margin: 0,
						background: theme.palette.accessibility.main,
						color: 'white'
					},
					'& .encart-content': {
						background: theme.palette.blue['5'],
						color: theme.palette.blue.main,

						'& > a': {
							textDecoration: 'none',
							display: 'block',
							width: 'fit-content',
							color: 'white',
							background: theme.palette.blue.main
						}
					}
				},

				'& .visuel': {
					position: 'relative',
					width: '100%',

					'& img': {
						width: '100%'
					},
					'& .caption': {
						wordBreak: 'break-word',
						padding: '16px 21px',
						background: theme.palette.blue.main,
						color: 'white',
						position: 'absolute',
						width: '50%',
						bottom: -20
					}
				},

				'& .cta': {
					background: theme.palette.blue.main,
					textAlign: 'center',

					'& h1': {
						margin: 0,
						color: 'white'
					},
					'& .cta-content': {
						color: 'white'
					},
					'& .cta-modal-trigger': {
						padding: '15px 24px',
						textDecoration: 'none',
						display: 'block',
						width: 'fit-content',
						color: 'white',
						background: theme.palette.accessibility.main,
						margin: 'auto',
						border: 'none',
						cursor: 'pointer',

						'&::before': {
							display: 'none'
						}
					}
				}
			},
			detailsContainerLargeScreenStyle: {
				'& p, & h1, & h2, & h3, & ul, & ol, & .encart, & .cta': {
					marginTop: 0,
					marginBottom: 25
				},
				'& h1': styles(theme).title2,
				'& h2': styles(theme).title3,
				'& h3': styles(theme).text11,
				'& p, & li': styles(theme).text1,

				'& table': {
					'& caption': {
						...styles(theme).title3,
						marginBottom: 20
					},
					'& thead tr': {
						height: 43,

						'& th': {
							...styles(theme).text8,
							paddingLeft: 27
						}
					},
					'& tbody tr': {
						height: 43,

						'& td': {
							...styles(theme).text15,
							paddingLeft: 27
						}
					}
				},

				'& ul, & ol': {
					'& li': {
						paddingLeft: 33
					}
				},

				'& .encart': {
					'& > h1': {
						padding: '25px 50px',
						...styles(theme).text11
					},
					'& .encart-content': {
						padding: '34px 50px 48px',
						...styles(theme).text1,

						'& > a': {
							marginTop: 37,
							padding: '23px 40px',
							...styles(theme).text8
						}
					}
				},

				'& .visuel': {
					marginBottom: 71,
					'& .caption': {
						...styles(theme).text17
					}
				},

				'& .cta': {
					padding: '65px 20%',

					'& h1': {
						...styles(theme).title2,
						marginBottom: 30
					},

					'& .cta-content': {
						...styles(theme).text1
					},

					'& .cta-modal-trigger': {
						marginTop: 30,
						...styles(theme).text8
					}
				}
			},
			detailsContainerSmallScreenStyle: {
				'& p, & h1, & h2, & h3, & ul, & ol, & .encart, & .cta': {
					marginTop: 0,
					marginBottom: 25
				},
				'& h1': styles(theme).title3,
				'& h2': styles(theme).title7,
				'& h3': styles(theme).title4,
				'& p, & li': styles(theme).text2,

				'& table': {
					'& caption': {
						...styles(theme).title7,
						marginBottom: 15
					},
					'& thead tr': {
						height: 35,

						'& th': {
							...styles(theme).text4,
							paddingLeft: 15
						}
					},
					'& tbody tr': {
						height: 35,

						'& td': {
							...styles(theme).text3,
							paddingLeft: 15
						}
					}
				},

				'& ul, & ol': {
					'& li': {
						paddingLeft: 15
					}
				},

				'& .encart': {
					'& > h1': {
						padding: '15px 25px',
						...styles(theme).title4
					},
					'& .encart-content': {
						padding: '15px 25px',
						...styles(theme).text2,

						'& > a': {
							marginTop: 20,
							padding: '15px 20px',
							...styles(theme).text4
						}
					}
				},

				'& .visuel': {
					marginBottom: 56,
					'& .caption': {
						...styles(theme).text17
					}
				},

				'& .cta': {
					padding: '40px 30px',

					'& h1': {
						...styles(theme).title4,
						marginBottom: 15
					},

					'& .cta-content': {
						...styles(theme).text2
					},

					'& .cta-modal-trigger': {
						marginTop: 15,
						...styles(theme).text8
					}
				}
			},
			imageStyle: {
				position: 'absolute',
				zIndex: 1
			},
			imageLargeScreenStyle: {
				right: 95,
				height: 285,
				width: 350
			},
			imageSmallScreenStyle: {
				right: 25,
				height: 150,
				width: 180
			},
			textContainerStyle: {
				'& > .link': {
					position: 'relative',
					background: 'white',

					'& > a': {
						position: 'absolute'
					}
				}
			},
			textContainerLargeScreenStyle: {
				paddingTop: '8vh',

				'& > .link': {
					padding: '140px 95px 85px',

					'& > a': {
						left: 95,
						top: 45
					}
				}
			},
			textContainerSmallScreenStyle: {
				paddingTop: '5vh',

				'& > .link': {
					padding: '70px 25px 25px',

					'& > a': {
						top: 20,
						left: 25
					}
				}
			},
			titleStyle: {
				marginTop: '10px !important'
			}
		}
	)
)

interface MatchParamsModel {
	id: string
}

interface AcceptingProps {
	isPreview?: boolean,
	content?: ServiceContentModel
}

interface Store {
	accessibility: AccessibilityModel
}

const initialNews: ServiceContentModel = {
	id: '',
	id_crm: '',
	title: '',
	picture: '',
	alternative_text: '',
	hook: '',
	content: '',
	order: '',
	date: '',
	picto: '',
	picto_alternative_text: ''
}
const COMPONENT_NAME = 'details'

type ServiceDetailsProps = AcceptingProps & Store

const ServiceDetails: React.FC<ServiceDetailsProps> = (
	{
		isPreview,
		content,
		accessibility
	}
) => {
	const classes = useStyle({ accessibility })
	const history = useHistory()
	const match = useRouteMatch<MatchParamsModel>()
	const intl = useIntl()
	const oldLanguage = useRef(intl.locale)

	const services = useSelector((state: RootState) => state.services)
	const [selectedService, setSelectedService] = useState<ServiceContentModel>(content || initialNews)
	const [loading, setLoading] = useState(false)
	const dispatch = useDispatch()
	const errorMessage = intl.formatMessage(
		{
			id: 'services.details.error',
			defaultMessage: 'Le service demandé n\'a pas été trouvé',
			description: 'Error message'
		}
	)

	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const detailContainerClass: ClassValue = classNames(
		classes.detailsContainerStyle,
		isLargeScreen ? classes.detailsContainerLargeScreenStyle : classes.detailsContainerSmallScreenStyle
	)

	const imageClass: ClassValue = classNames(
		classes.imageStyle,
		isLargeScreen ? classes.imageLargeScreenStyle : classes.imageSmallScreenStyle
	)

	const textContainerClass: ClassValue = classNames(
		classes.textContainerStyle,
		{
			[classes.textContainerLargeScreenStyle]: isLargeScreen,
			[classes.textContainerSmallScreenStyle]: !isLargeScreen
		}
	)

	const titleClass: ClassValue = classNames(
		classes.title1,
		classes.colorAccessibility,
		classes.titleStyle
	)

	const goToServices = useCallback(
		() => {
			history.push(links.services)
		}, [history]
	)

	const checkId = useCallback(
		(servicesParam: ServiceContentModel[], idInUrl: string) => {
			const service = servicesParam.find(
				(service) => service.id === idInUrl
			)

			if (!!service) {
				setSelectedService(service)
			} else {
				dispatch(
					displaySnackbar(
						{
							id: COMPONENT_NAME,
							message: errorMessage,
							open: true,
							hideIcon: true
						}
					)
				)

				goToServices()
			}
		}, [dispatch, errorMessage, goToServices]
	)

	useEffect(
		() => {
			setLoading(true)
			const idInUrl = match.params.id
			window.scrollTo(0, 0)

			if ((!isPreview && (services.content.length === 0 || oldLanguage.current !== intl.locale)) || (!content && isPreview)) {
				fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/information/getServices?language=${intl.locale}`)
					.then(
						(servicesResponse: any) => {
							dispatch(
								saveServices(servicesResponse)
							)

							oldLanguage.current = intl.locale
							checkId(servicesResponse, idInUrl)
						}
					)
					.catch(
						(err) => {
							dispatch(
								errorCatcher(err, COMPONENT_NAME)
							)
						}
					)
					.finally(
						() => {
							setLoading(false)
						}
					)
			} else {
				checkId(services.content, idInUrl)
				setLoading(false)
			}
		}, [services.content, checkId, dispatch, intl.locale, match.params.id, goToServices, content, isPreview]
	)

	const openModal = useCallback(
		() => {
			dispatch(
				displayModal(
					modalTypes.service,
					{
						id_crm: selectedService.id_crm,
						title: selectedService.title
					}
				)
			)
		}, [dispatch, selectedService]
	)

	useEffect(
		() => {
			const buttonsRef = window.document.querySelectorAll('.cta-modal-trigger')

			buttonsRef.forEach((button: Element) => {
				button.addEventListener('click', (e) => {
					openModal()
					e.preventDefault()
				})
			})
		}, [selectedService, openModal]
	)

	if (loading) {
		return (
			<Loader />
		)
	}

	return (
		<div className={detailContainerClass}>
			<img
				src={selectedService.picture}
				alt={selectedService.alternative_text || 'Service pic'}
				className={imageClass}
			/>

			<div className={textContainerClass}>
				<div className="link">
					{
						!content && (
							<Link
								color="colorAccessibility"
								textStyle="text4"
								hasChevron={false}
								onClick={goToServices}
							>
								<KeyboardArrowLeftIcon />

								<FormattedMessage
									id="app.back"
									defaultMessage="Retour"
									description="Back button"
								/>
							</Link>
						)
					}

					<div>
						<img
							src={selectedService.picto}
							alt={selectedService.picto_alternative_text || 'Picto pic'}
							width={isLargeScreen ? 80 : 40}
							height={isLargeScreen ? 80 : 40}
						/>

						<h1 className={titleClass}>{selectedService.title}</h1>
					</div>

					<span className="content">
						{parse(selectedService.content || '')}
					</span>
				</div>
			</div>

			{
				services.content.length > 1 && !content &&
				<ServiceCarousel services={services.content.filter((service) => service.id !== selectedService.id)} />
			}
		</div>
	)
}

const mapStateToProps = (state: RootState) => (
	{
		accessibility: state.accessibility
	}
)

export default connect(mapStateToProps)(ServiceDetails)
